import React, { useState } from "react";
import styles from "./typology.module.css";
import { Box, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

export default function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>

 <Head>
        <title>Tarot Typology | School of Our Divine Infinite Being</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <meta name="keywords" content="Jungian Typology, MBTI, Court Cards, Tarot, Personality Types, Carl Jung"></meta>
        <meta name="description" content="Explore the intricate relationship between Jungian typology and tarot at the School of Divine Infinite Being. Understand the personality dynamics mirrored in our unique Tarot cards. Learn more about how we integrate Carl Jung's psychological types with our tarot readings to provide deeper insights and personal growth."></meta>
        
        <meta property="og:title" content="Tarot Typology at the School of Divine Infinite Being | School of Our Divine Infinite Being"></meta>
        <meta property="og:type" content="website" ></meta>
        <meta property="og:url" content="https://www.divineinfinitebeing.com/tarot-typology"></meta>
        <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/tarot_typo_og_img.webp"></meta>
        <meta property="og:image:alt" content="Mystical tarot card spread reflecting Jungian typology"></meta>
        <meta property="og:description" content="Explore the intricate relationship between Jungian typology and tarot at the School of Divine Infinite Being. Understand the personality dynamics mirrored in our unique Tarot cards. Learn more about how we integrate Carl Jung's psychological types with our tarot readings to provide deeper insights and personal growth."></meta>
        
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/tarot_typo_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="Explore the Jungian typology through tarot cards at the School of Divine Infinite Being"></meta>
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:title" content="Tarot Typology at the School of Divine Infinite Being | School of Our Divine Infinite Being"></meta>
        <meta property="twitter:url" content=" https://www.divineinfinitebeing.com/tarot-typology "></meta>
        <meta property="twitter:description" content="Explore the intricate relationship between Jungian typology and tarot at the School of Divine Infinite Being. Understand the personality dynamics mirrored in our unique Tarot cards. Learn more about how we integrate Carl Jung's psychological types with our tarot readings to provide deeper insights and personal growth."></meta>
        
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta property="og:url" content=" https://www.divineinfinitebeing.com/tarot-typology "></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/tarot-typology" />
 
    </Head>


    
      {/* ////////////////////////////////////Souvik-start////////////////////////////////// */}

      {/* <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d1.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d2.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d3.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d4.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d5.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d6.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d7.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d8.webp"  />
        <img className={styles.img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/d9.webp"  /> */}
      <div className={styles.typology_main}>
        <div className={styles.homeblockone}>
          <div className={styles.asmainwrapper}>
            <div className={styles.homeblockoneleft}>
              <span className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                  />
                </span>
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                />
              </span>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="INFINITE BEING">INFINITE BEING</h1>
              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div className={styles.bannerboxtxt}>
                <p> </p>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew />

        <div className={styles.TT_block1}>
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <span className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>
                  Jungian Typology and the Court Cards of the Tarot:
                  Introduction
                </h1>
              </div>
            </span>
          </div>
          <div className={styles.common_width}>
            <div className={`${styles.CM_components_main} ${styles.CMcompo1}`}>
              <div className={styles.CM_Compo_image}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/TT_block1_img1.webp" /> */}

                <img
                  src={`${process.env.cloud_url}tarot_typology/TT_block1_img1.webp`}
                />
              </div>
              <div className={styles.CM_Compo_content}>
                <div className={styles.border_box}></div>
                <div className={styles.CM_Compo_content_text}>
                  <p>
                    The School of Our Divine Infinite Being fully embraces the
                    genius and depth of Carl Jung and his various developments
                    in psychology. One of his most famous developments is the
                    idea of <i> “Introverted” </i> and <i>“Extroverted”</i>,
                    something everyone has now heard of and uses. These terms
                    come from Jung’s work in a more widely studied field called
                    Typology. Typology and its development was an in-depth
                    project for Jung and he worked on it his entire career. His
                    book <i> “Psychological Types”</i>, the work where most of
                    this stems from, was the largest volume of his entire
                    corpus. Many famous psychologists have continued that work
                    including James Hillman and Marie Von Franz.
                  </p>

                  <p>
                    The project was picked up and perfected by the Myers-Briggs’
                    team and changed into the now infamous MBTI personality
                    test. This test allows individuals to answer a series of
                    questions and thereby result in answers concerning their
                    psychological disposition, tendencies, and values. From the
                    12 original psychological types Meyers-Brings ended with 16
                    they termed personality types. The 16 personalities have
                    continued their development through various authors,
                    podcasters, and the Myers-Briggs foundation themselves.
                    Millions of people take the Meyers-Briggs test per year and
                    millions more find it to be of value in their lives. The
                    Meyers-Briggs method has become widely known as MBTI, which
                    is how we will reference it throughout the rest of this
                    essay.
                  </p>

                  <p>
                    Several authors over time compared MBTI to the Court Card
                    alchemy of the Tarot. The symbolic concepts were so closely
                    related that it has become widely known that this connection
                    has significance. Many occult scholars worked on this idea
                    and now there is literature and articles well established
                    that explain the correlations. Our mystery school has
                    continued this process and fully integrated Jungian Typology
                    in our Young Adult programs and the court cards of the
                    Divine Tarot.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.TT_block2}>
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <span className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>Jungian Typology and the Court Cards of the Tarot</h1>
              </div>
            </span>
          </div>
          <div className={styles.common_width}>
            <div className={`${styles.CM_components_main} ${styles.CMcompo1}`}>
              <div className={styles.CM_Compo_image}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/TT_block2_img1.webp" /> */}
                <img
                  src={`${process.env.cloud_url}tarot_typology/TT_block2_img1.webp`}
                />
              </div>
              <div className={styles.CM_Compo_content}>
                <div className={styles.border_box}></div>
                <div className={styles.CM_Compo_content_text}>
                  <p>
                    Introverts are more comfortable living alone and being by
                    themselves. They depend on their <i> “me time” </i> to
                    recharge; they become immersed in their inner world and run
                    the risk of losing touch with their surroundings or their
                    outer world.
                  </p>

                  <p>
                    Extroverts, on the contrary, are actively involved in the
                    world of people and things; they are socially active and
                    more aware of what is going on around them.
                  </p>

                  <i>
                    “Perception involves all the ways of becoming aware of
                    things, people, happenings, or ideas. Judgment involves all
                    the ways of coming to conclusions about what has been
                    perceived. If people differ systematically in what they
                    perceive and in how they reach conclusions, then it is only
                    reasonable for them to differ correspondingly in their
                    interests, reactions, values, motivations, and skills”.
                  </i>

                  <h5
                    className={`${styles.red_rightAlgn} ${styles.red_rightAlgn_margin}`}
                  >
                    Carl Jung
                  </h5>

                  <i>
                    “The purpose of the Myers-Briggs Type Indicator® (MBTI®)
                    personality inventory is to make the theory of psychological
                    types described by C. G. Jung, understandable and useful in
                    people's lives. The essence of the theory is that much
                    seemingly random variation in the behavior is actually quite
                    orderly and consistent, being due to basic differences in
                    the ways individuals prefer to use their perception and
                    judgment”.
                  </i>

                  <h5
                    className={`${styles.red_rightAlgn} ${styles.red_rightAlgn_margin}`}
                  >
                    The Meyer Briggs Foundation
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.TT_block3_main_wrapper}>
          <div className={styles.common_width}>
            <div className={styles.TT_block3_sub_main_wrapper}>
              <div className={styles.TT_block3_sub1_wrapper}>
                <h1>MBTI Version</h1>
              </div>
              <div className={styles.TT_block3_sub2_wrapper}>
                <div className={styles.TT_block3_sub2_mini1_wrapper}>
                  <p>Extraversion (E)</p>
                </div>
                <div className={styles.TT_block3_sub2_mini2_wrapper}>
                  <p> Introversion (I)</p>
                </div>
              </div>
              <div className={styles.TT_block3_sub2_wrapper}>
                <div className={styles.TT_block3_sub2_mini1_wrapper}>
                  <p>iNtuition (N) </p>
                </div>
                <div className={styles.TT_block3_sub2_mini2_wrapper}>
                  <p> Sensation (S)</p>
                </div>
              </div>
              <div className={styles.TT_block3_sub2_wrapper}>
                <div className={styles.TT_block3_sub2_mini1_wrapper}>
                  <p>Thinking (T)</p>
                </div>
                <div className={styles.TT_block3_sub2_mini2_wrapper}>
                  <p> Feeling (F)</p>
                </div>
              </div>
              <div className={styles.TT_block3_sub2_wrapper}>
                <div className={styles.TT_block3_sub2_mini1_wrapper}>
                  <p>Judging (J)</p>
                </div>
                <div className={styles.TT_block3_sub2_mini2_wrapper}>
                  <p> Perception (P)</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.TT_block4_main_wrapper}>
          <div className={styles.full_block_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.tarot_typology_main_body}>
                <div className={styles.block2_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_tropology_block4_1st_img.webp"
                      /> */}

                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_tropology_block4_1st_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.yellow_heading}>
                        <h1>Functions: </h1>
                      </div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Extraversion: </h6>
                        <p>
                          A strong, if not exclusive, determination by the
                          object. If man thinks, feels, acts, and actually lives
                          in a way that is directly correlated with the
                          objective conditions and their demands, he is
                          extraverted. Objective NOT subjective.{" "}
                        </p>

                        <h6>Introversion:</h6>

                        <p>
                          {" "}
                          A turning inwards of the libido, whereby a negative
                          relation of subject to object is expressed. Interest
                          does not move towards the object, but recedes towards
                          the subject. Everyone whose attitude is introverted
                          thinks, feels, and acts in a way that clearly
                          demonstrates that the subject is the chief factor of
                          motivation while the object at most receives only a
                          secondary value.{" "}
                        </p>
                        <h6>Thinking:</h6>
                        <p>
                          Thinking is that psychological function which, in
                          accordance with its own laws, brings given
                          presentations into conceptual connection.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block1_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_tropology_block4_2nd_img_new.webp"
                      /> */}
                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_tropology_block4_2nd_img_new.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Feeling:</h6>

                        <p>
                          Feeling is primarily a process that takes place
                          between the ego and a given content, a process,
                          moreover, that imparts to the content a definite value
                          in the sense of acceptance or rejection. Hence feeling
                          is also a kind of judging, differing, however, from an
                          intellectual judgment, in that it does not aim at
                          establishing an intellectual connection but is solely
                          concerned with the setting up of a subjective
                          criterion of acceptance or rejection.
                        </p>
                        <h6>Sensation:</h6>

                        <p>
                          Sensation is that psychological function which
                          transmits a physical stimulus to perception. Not only
                          to the outer stimuli, but also to the inner, i.e. to
                          changes in the internal organs. Primarily, therefore,
                          sensation is sense-perception, i.e. perception
                          transmitted via the sense organs and bodily senses.
                          Also, since the process of conscious perception is a
                          psychological phenomenon representing a physical
                          phenomenon, and not the physical phenomenon itself,
                          Jung says:{" "}
                          <i>
                            "On the one hand, it is an element of presentation,
                            since it transmits to the presenting function the
                            perceived image of the outer object; on the other
                            hand, it is an element of feeling, because through
                            the perception of bodily changes it lends the
                            character of affect to feeling.”
                          </i>{" "}
                        </p>
                        <h6>Intuition:</h6>
                        <p>
                          Intuition is that psychological function which
                          transmits perceptions in an unconscious way.
                          Everything, whether outer or inner objects or their
                          associations, can be the object of this perception.
                          Intuition has this peculiar quality: it is neither
                          sensation, nor feeling, nor intellectual conclusion,
                          although it may appear in any of these forms.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.TT_block5_main_wrapper}>
          <div className={styles.full_block_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.tarot_typology_main_body}>
                <div className={styles.block2_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block5_1st_img.webp"
                      /> */}
                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block5_1st_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <h6>Extraverted Thinking: </h6>
                        <p>
                          They rely on object and objective data. An objective
                          idea is equally determined by external data or
                          borrowed from outside even when it is subjectively
                          sanctioned. Extraverted thinking need not necessarily
                          be purely concretistic thinking, it can just as well
                          be purely ideal thinking. By what criterion does it
                          judge–does it come from outside, or is its origin
                          subjective? What direction does it take in drawing
                          conclusions, whether it is directed outwards or not?
                          Extraverted thinking comes into existence only when
                          the objective orientation predominates. They have to
                          have a different standpoint, a standpoint of their
                          own. Because of this different standpoint, they see
                          only the outward aspect, not the essence, whereas the
                          thinker themselves can apprehend its essence but not
                          its outward aspect. Extraverts need the influence of
                          the introverted and vice versa.{" "}
                        </p>

                        <h6>Extraverted Feeling:</h6>

                        <p>
                          {" "}
                          Extraverted feeling is concerned with phenomena to be
                          harmonious with its external environment. Jung writes
                          of extraverted feelers as those where feeling loses
                          its personal character - it becomes feeling per se; it
                          almost seems as though the personality were wholly
                          dissolved in the feeling of the moment. Now, since
                          actual life situations constantly and successively
                          alternate, in which the feeling-tones released are not
                          only different but are actually mutually contrasting,
                          the personality inevitably becomes dissipated in just
                          so many different feelings.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block1_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block5_2nd_img.webp"
                      /> */}

                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block5_2nd_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Extraverted Sensation:</h6>

                        <p>
                          Extraverted sensation is the sensing function that
                          perceives phenomena in a realistic and concretist way.
                          Since an extraverted sensor type's source of reward
                          gravitates around perceiving and feeling external
                          phenomena, he often has a good sense of aesthetics.{" "}
                        </p>
                        <h6>Extraverted Intuition:</h6>
                        <p>
                          Extraverted Intuition takes in intuitive information
                          from the world around, Extraverted Intuition is
                          concerned with the collective conscious. The
                          collective conscious used by the Extraverted
                          Intuitive, however, sees archetypes reflected through
                          the subcultures, celebrities, organizations, events,
                          and ideas of their times.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.TT_block6_main_wrapper}>
          <div className={styles.full_block_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.tarot_typology_main_body}>
                <div className={styles.block2_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block6_1st_img.webp"
                      /> */}
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typologblock6_1st_img_new.webp"
                      /> */}
                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typologblock6_1st_img_new.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <h6>Introverted Thinking:</h6>
                        <p>
                          They rely on the subjective. The nature of introverted
                          thinking means that it is primarily concerned with its
                          subjective idea and insights gained by formulation
                          over facts and objective data. Introverted Thinking is
                          most similar to Rationalism. He is decisively
                          influenced by ideas; these, however, have their
                          origin, not in the objective data but in the
                          subjective foundation. Like the extravert, he too will
                          follow his ideas, but in the reverse direction:
                          inwardly not outwardly. Intensity is his aim, not
                          extensity. In these fundamental characters he differs
                          markedly, indeed quite unmistakably from his
                          extraverted parallel. Like every introverted type, he
                          is almost completely lacking in that which
                          distinguishes his counter type, namely, the intensive
                          relatedness to the object.{" "}
                        </p>

                        <h6>Introverted Feeling:</h6>

                        <p>
                          {" "}
                          Introverted feeling is continually seeking an image
                          which has no existence in reality, but which it has
                          seen in a kind of vision. It glides over all objects
                          that do not fit in with its aim. It strives for inner
                          intensity, for which the objects serve at most as a
                          stimulus. The depth of this feeling can only be
                          guessed—it can never be clearly grasped. It makes
                          people silent and difficult to access; it shrinks back
                          like a violet from the brute nature of the object in
                          order to fill the depths of the subject. It comes out
                          with negative judgments or assumes an air of profound
                          indifference as a means of defense.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block1_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block6_2nd_img.webp"
                      /> */}
                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block6_2nd_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Introverted Sensation:</h6>

                        <p>
                          Introverted sensation is where the subject perceives
                          the same things as everybody else, only, never stops
                          at the purely objective effect, but concerns with the
                          subjective perception released by the objective
                          stimulus. Subjective perception differs remarkably
                          from the objective. It is either not found at all in
                          the object, or, at most, merely suggested by it.
                          Subjective, or introverted, sensation apprehends the
                          background of the physical world rather than its
                          surface. The decisive thing is not the reality of the
                          object, but the reality of the subjective factor, like
                          the primordial images, which in their totality
                          represent a psychic mirror-world. It is a mirror,
                          however, with the peculiar capacity of representing
                          the present contents of consciousness not in their
                          known and customary form but in a certain sense sub
                          species aeternitatis, somewhat as a million-year old
                          consciousness might see them. Such a consciousness
                          would see the becoming and the passing of things
                          beside their present and momentary existence, and not
                          only that, but at the same time it would also see that
                          Other, which was before their becoming and will be
                          after their passing.
                        </p>
                        <h6>Introverted Intuition:</h6>
                        <p>
                          Intuition, in the introverted attitude, is directed
                          upon the inner object, a term we might justly apply to
                          the elements of the unconscious. For the relation of
                          inner objects to consciousness is entirely analogous
                          to that of outer objects, although theirs is a
                          psychological and not a physical reality. Inner
                          objects appear to the intuitive perception as
                          subjective images of things, which, though not met
                          with in external experience, really determine the
                          contents of the unconscious, i.e. the collective
                          unconscious, in the last resort. Although this
                          intuition may receive its impetus from outer objects,
                          it is never arrested by the external possibilities,
                          but stays with that factor which the outer object
                          releases within. Introverted intuition apprehends the
                          images which arise from the a priori, i.e. the
                          inherited foundations of the unconscious mind. These
                          archetypes, whose innermost nature is inaccessible to
                          experience, represent the precipitate of psychic
                          functioning of the whole ancestral line, i.e. the
                          heaped-up, or pooled, experiences of organic existence
                          in general, a million times repeated, and condensed
                          into types. Hence, in these archetypes all experiences
                          are represented which since primeval time have
                          happened on this planet. Their archetypal distinctness
                          is the more marked, the more frequently and intensely
                          they have been experienced. The archetype would be—to
                          borrow from Kant—the noumenon of the image which
                          intuition perceives and, in perceiving, creates.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.TT_block7_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
            >
              <div className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>Types/Combinations:</h1>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.full_block7_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.tarot_typology_main_body}>
                <div className={`${styles.block2_full_width} ${styles.sec1}`}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_1st_img.webp"
                      /> */}
                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_1st_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <h6>Extraverted Thinking Type: </h6>
                        <p>
                          They base their ‘activities’ or actions on
                          intellectual conclusions, they use objective knowledge
                          and data as their foundation. Has an internal formula
                          that determines good and evil, beauty and ugliness.
                          They are strict with what is right and wrong, what
                          confirms or contradicts their beliefs/formulas.
                          Everyone and everything must obey this ‘formula’ or
                          else they are wrong. This thinking type obeys it for
                          their own good, so everyone else must obey it too. The
                          formula is the universal law and anyone who opposes or
                          does not obey it, is defying that law; those
                          individuals who are insubordinate are therefore
                          unreasonable, immoral and without conscience. His
                          ideal is the purest conceivable formulation of object
                          reality which therefore makes it the universally valid
                          truth for the salvation of mankind. He stands for
                          justice and truth. Don’t get too close to the center
                          of their ‘power’ (where the formula operates), stay in
                          the periphery. This type doesn’t like to be dependent
                          on feeling(s), they repress things of illogical sense
                          such as religious experiences or artistic sense, they
                          are a rigid intellectual type. They believe that they
                          are superior to feelings. They are positive thinkers,
                          meaning they are also productive. The thinking of this
                          type is the main channel into which his vital energy
                          flows. This thinking/thought has a progressive,
                          creative quality.{" "}
                        </p>

                        <h6>Feeling:</h6>

                        <p>
                          {" "}
                          Oriented with objective data, the object being the
                          indispensable determinant of the quality of feeling.
                          Their feelings are always in accordance with the
                          objective values, this type detaches from the
                          subjective factor and entirely to the influence of the
                          object. The valuations resulting from the act of
                          feeling either correspond directly with the objective
                          values or accord with traditional and generally
                          accepted standards. Unconsciously egocentric.
                          Overextraverted feeling may satisfy aesthetic
                          expectations, but it does not speak to the heart; it
                          appeals merely to the senses or only to reason.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.block1_full_width} ${styles.sec2}`}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_2nd_img.webp"
                      /> */}
                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_2nd_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Extraverted Feeling Type: </h6>

                        <p>
                          Follows feelings as a guide throughout life. Their
                          personality appears adjusted in relation to external
                          conditions, their feelings harmonize with objective
                          situations and general values. Everything that fits
                          into objective values is good and is loved and
                          everything else seems to them seems a world apart. It
                          is understandable that this type of thinking will be
                          kept in abeyance as much as possible, this does not
                          mean that they do not think, but their thinking comes
                          in accordance with their heart. What they cannot feel,
                          they cannot consciously think. To the observer, the
                          display of feeling no longer appears as a personal
                          expression of the subject but as an alteration of the
                          ego– a mood. Thinking totally shuts out feeling if
                          ever it wants to reach any kind of pure results, for
                          nothing is more liable to prejudice and falsify
                          thinking than feeling values. Logic nevertheless
                          exists and enforces its inexorable conclusions, this
                          must take place somewhere, and it takes place outside
                          consciousness, namely the unconscious. The stronger
                          the conscious feeling is and the more ego-less it
                          becomes, the stronger grows the unconscious
                          opposition. The unconscious thinking reaches the
                          surface in the form of the obsessive ideas which are
                          invariably of a negative and depreciatory character.
                          The negative thinking utilizes every infantile
                          prejudice or comparison for the deliberate purpose of
                          casting aspersions on the feeling value, and musters
                          every primitive instinct in the attempt to come out
                          with <i>“nothing but”</i> interpretations.
                        </p>

                        <h6>Extraverted Sensation Type: </h6>

                        <p>
                          No one can match this type in realism, their sense for
                          objective facts is extraordinarily developed. Their
                          life is an accumulation of actual experiences of
                          concrete objects. What they experience serves at most
                          as a guide to fresh sensations; anything new that
                          comes within their range of interest is acquired by
                          way of sensation and has to serve its ends. This type
                          is one who is inclined to regard a highly developed
                          reality-sense as a sign of rationality, such people
                          will be esteemed as very rational. Sensation is a
                          concrete expression of life– it is simply real life
                          lived to the full. This type seeks after concrete
                          enjoyment in life, and their morality is oriented
                          accordingly. This type is the lover of tangible
                          reality, with little inclination for reflection and no
                          desire to dominate; they enjoy feeling the object, to
                          have sensations, and then enjoying them. Their love
                          for enjoyment draws people to them, they make good
                          company. This type is desirous of the strongest
                          sensations, and these, by their very nature, they can
                          receive only from outside. What comes from inside
                          seems to him morbid and suspect. He reduces his
                          thoughts and feelings to objective causes, to
                          influences emanating from objects, quite unperturbed
                          by the violations of logic. Their love is
                          unquestionably rooted in the physical attractions of
                          its object. They are considerate to others. They have
                          no reason to act in any way contrary to the reality of
                          things as they are. This type is compulsive, it is the
                          unconscious counterpart of the easy-going attitude of
                          the pure sensation type.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.block2_full_width} ${styles.sec3}`}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_3rd_img.webp"
                      /> */}

                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_3rd_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <h6>Extraverted Intuition Type:</h6>
                        <p>
                          This type is oriented by the object, there is a marked
                          dependence on external situations, but it is
                          altogether different from the dependence of the
                          sensation type. This type is never to be found in the
                          world of accepted reality-values, they have a keen
                          nose for anything new and in the making. They are
                          always seeking out new possibilities, stable
                          conditions suffocate them. They have a hard time with
                          long term goals, they oftentime pursue things with
                          great enthusiasm only to abandon them without any
                          compunction. Neither reason nor feeling can restrain
                          or frighten them away from a new possibility even
                          though it goes against all his previous convictions.
                          This type has a lack of judgment. They also have their
                          own characteristic morality which consists in a
                          loyalty to their vision and in voluntary submission to
                          their vision’s authority; they are not very
                          inconsiderate of others. They are seen as immoral and
                          unscrupulous adventurers. This type is important
                          economically and culturally; they are exceptional
                          initiators and promoters of enterprises as well as
                          they are ‘champions’ of minorities with a future; they
                          are able to make intuitive ‘diagnosis’ of their
                          abilities and potentialities. They are capable of
                          inspiring courage in others and kindle enthusiasm for
                          anything new. The stronger their visions and intuition
                          are, the more egotistical they become, but they bring
                          their visions to life and are passionate and embody
                          them. However, they tend to create and envision things
                          that they don’t stick around long enough to see or be
                          a part of; they run after new things constantly and
                          never stop to see what they have created. This can
                          oftentimes make them feel very empty and unfulfilled.
                          Their conscious attitude towards both sensation and
                          object is one of ruthless superiority. They do not
                          necessarily mean to be ruthless or superior— they
                          simply do not see the object everyone else sees and
                          rides roughshod over it, just as the sensation type
                          has no eyes for its soul.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.block1_full_width} ${styles.sec4}`}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_4th_img.webp"
                      /> */}

                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_4th_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Introverted Thinking Type:</h6>

                        <p>
                          this type is very strongly influenced by ideas, the
                          origin of those ideas however are in their subjective
                          foundation, not objective data. They follow their
                          ideas inwardly; intensity in their aim rather than
                          extensity. They may be polite, amiable, and kind, but
                          one is constantly aware of a certain uneasiness
                          betraying an ulterior motive– the disarming of an
                          opponent, who must at all costs be pacified and
                          placated lest they prove themself a nuisance. They
                          won’t shrink from no danger in building up their world
                          of ideas, and never shrinks from thinking a thought
                          because it might prove to be dangerous, subversive,
                          heretical, or wounding to other people’s feelings,
                          they have nonetheless beset by the greatest anxiety if
                          ever they have to make an objective reality. That goes
                          against the grain. They put their ideas into the world
                          and get really annoyed when they fail to thrive on
                          their own account. If in their eyes what they say and
                          do are true, then it must be so in practice, and
                          others have to bow to its truth. This type is
                          stubborn, headstrong, and unamenable to influence.
                          This type tends to not see that they are being wronged
                          in practice, for to them the relation to people and
                          things is secondary and the objective evaluation of
                          their product is something they remain unconscious
                          because they think out their problems to the limit,
                          they complicate them and constantly get entangled in
                          their own scruples and misgivings. They tend to have
                          difficulty when they bring themselves to admit that
                          what is clear to them, may not be equally clear to
                          everyone else. When it comes to their personal
                          relationships and relations with people, they are shy
                          or they can throw themselves at people who cannot
                          understand them. If they think they are understood,
                          they can easily become arrogant. They can be very
                          clueless when it comes to relationships and can easily
                          be taken advantage of. He can seem to others
                          inconsiderate and domineering, prickly,
                          unapproachable, and arrogant, but for those who have
                          stuck with them know value this type’s intimacy and
                          friendship. This type is antisocial. This type relies
                          on his close relationships and lashes out at what
                          seems to be insignificant things, they begin to
                          confuse their subjective truth to their own
                          personality. Their original ideas become destructive,
                          poisoned by a sediment of bitterness. Their struggle
                          against the influences emanating from the unconscious
                          increases with their external isolation, until finally
                          they begin to cripple them. They think their
                          withdrawal into ever-increasing solitude will protect
                          them from the unconscious influences, but it only
                          plunges them deeper into the conflict that is
                          destroying them from within. This type is positive and
                          synthetic in developing ideas.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.block2_full_width} ${styles.sec5}`}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_5th_img.webp"
                      /> */}
                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_5th_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <h6>Introverted Feeling Type: </h6>
                        <p>
                          This type is mostly silent, inaccessible, and hard to
                          understand. They often hide behind childish or banal
                          masks, and their temperament is inclined to
                          melancholy. They are mainly guided by their subjective
                          feelings, their true motives generally remain
                          hidden. Their outward demeanor is harmonious,
                          inconspicuous, giving an impression of pleasing
                          repose, or of sympathetic response, with no desire to
                          affect others, to impress, influence, or change them
                          in any way. If this outward aspect is more pronounced,
                          it arouses a suspicion of indifference and coldness,
                          which may turn into a disregard for the comfort and
                          well-being of others. Faced with anything that might
                          carry them away or arouse enthusiasm, this type
                          observes a benevolent though critical neutrality,
                          coupled with a faint trace of superiority that soon
                          takes the wind out of the sails of a sensitive person.
                          As far as possible the feeling relationship is kept to
                          the safe middle path, all intemperate passions being
                          resolutely tabooed. Expressions of feeling therefore
                          remain stingy, and the other person has a permanent
                          sense of being undervalued once they become conscious
                          of it. This type appears cold and reserved, making it
                          seem like they have no feelings at all; however, the
                          truth is their feelings are intensive rather than
                          extensive. They develop feelings in depth. While an
                          extensive feeling of sympathy can express itself in
                          appropriate words and deeds, and thus quickly gets
                          back to normal again, an intensive sympathy, being
                          shut off from every means of expression, acquires a
                          passionate depth that comprises a whole world of
                          misery and simply gets benumbed. To the outside world
                          this intensive sympathy looks like coldness because
                          usually it does nothing visible, and an extraverted
                          consciousness is unable to believe in invisible
                          forces. The real object of this feeling is only dimly
                          divined by the normal type. A trace of it nevertheless
                          seeps through into the personal effect they have on
                          people in the form of a domineering influence often
                          difficult to define (A trace of a tendency to
                          overpower or coerce another person with their{" "}
                          <i>“secret feelings”</i> ). It is sensed as a sort of
                          stifling or oppressive feeling which holds everybody
                          around them under a spell. This type has a{" "}
                          <i>“mysterious power”</i> that is fascinating to
                          extraverts; this power comes from deeply felt,
                          unconscious images, but consciously they are apt to
                          relate it to the ego, whereupon her influence becomes
                          debased into personal tyranny. The mysterious power of
                          intensive feeling turns into a banal and overweening
                          desire to dominate, into vanity and despotic
                          bossiness. This type is known for their unscrupulous
                          ambition and mischievous cruelty. They feel what other
                          people think.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.block1_full_width} ${styles.sec6}`}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_6th_img.webp"
                      /> */}

                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_6th_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h6>Introverted Sensation Type:</h6>

                        <p>
                          This type is guided by the intensity of subjective
                          sensation excited by the objective stimulus. No
                          proportional relation exists between object and
                          sensation, but one that is apparently quite
                          unpredictable and arbitrary. They may be conspicuous
                          for their calmness and passivity or for their rational
                          self-control. This type has a difficulty in expressing
                          themselves. There is an unrelatedness to objects;
                          normally the object is not consciously devalued in the
                          least, but the stimulus is removed from it and
                          immediately replaced by a subjective reaction no
                          longer related to the reality of the object. Objective
                          stimulus is absolutely necessary to sensation and
                          merely produces something different from what the
                          external situation might lead one to expect. This type
                          notices everything and takes it in, they get
                          impressions which translate from the object to the
                          subject. They have a slow conscious function, but
                          their unconscious function is always interpreting
                          things and processing things on the interior. This
                          type’s superior function is introverted, their
                          intuition is extraverted and therefore is generally
                          triggered off by outer events. Their development
                          alienates them from the reality of the object, leaving
                          them at the mercy of their subjective perceptions,
                          which orient their consciousness to an archaic
                          reality, although their lack of comparative judgment
                          keeps them wholly unconscious of this fact. This type
                          lives in their own world and processes things on their
                          own time. Their sensations are different from reality.
                          Their unconscious is distinguished chiefly by the
                          repression of intuition which consequently acquires an
                          extraverted and archaic character.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${styles.block2_full_width} ${styles.sec7}`}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_block7_7th_img.webp"
                      /> */}

                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url}tarot_typology/tarot_typology_block7_7th_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <h6>Introverted Intuition Type:</h6>
                        <p>
                          This type can be seen as a mystical dreamer and seer
                          while also an artist and crank. The artist might be
                          regarded as the normal representative of this type
                          which tends to confine itself to the perceptive
                          character of intuition. The intuitive stops at
                          perception; perception is their main problem as well
                          as the shaping of perception. The moral problem arises
                          when the intuitive tries to relate themselves to their
                          vision when they are no longer satisfied with mere
                          perception and its aesthetic configuration and
                          evaluation. The pure intuitive who represses their
                          judgment, or whose judgment is held in thrall by their
                          perceptive faculties, never faces this question
                          squarely since his only problem is the{" "}
                          <i>“know-how”</i> of perception. They find the moral
                          problem unintelligible or even absurd and as far as
                          possible forbids their thoughts to dwell on the
                          disconcerting vision. They reflect on the meaning of
                          their visions and they are less concerned with
                          developing its aesthetic possibilities than with the
                          moral effects which emerge from its intrinsic
                          significance. Their judgment allows them to discern
                          though often only darkly that in their vision that it
                          is not just an object to be perceived, but wants to
                          participate in the life of the subject. They transform
                          their vision into their own life, they tend to rely
                          predominantly on their vision, their moral efforts
                          become one-sided; they make themselves and their life
                          symbolic– adapted to the inner and eternal meaning of
                          events, but unadapted to present-day reality. This
                          type speaks words ahead of their time, a sort of
                          language that no one understands yet, and they lack
                          the convincing power of reason. They are often a
                          frequently misunderstood geniuses. This type represses
                          most of all is the sensation of the object, and colors
                          their whole unconscious. It gives rise to an
                          extraverted sensation function. The unconscious
                          personality can best be described as an extraverted
                          sensation type of a rather low and primitive order.
                          Instinct and intemperance are hallmarks for sensation
                          combined with an extraordinary dependence on
                          sense-impressions.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ////////////////////////////////////Souvik-End////////////////////////////////// */}

      {/* ////////////////////////////////////BISWARUP////////////////////////////////// */}

      {/* -----------------------------------Tarot-Typology-Part2-START--------------------------------------- */}

      <div
        className={`${styles.tarot_typology_block_main_wrapper} ${styles.tarot_typology_block_main_wrapper_part2}`}
      >
        <div className={styles.block1_main_wrpr}>
          <div className={styles.common_width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
            >
              <div className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>
                    Jungian Typology, MBTI, and the Court <br></br>Cards of the
                    Tarot
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.full_block_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.tarot_typology_main_body}>
                <div className={styles.block1_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block1_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block1_img.webp"
                                            /> */}
                      <img
                        className={styles.block1_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block1_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <p>
                          Carl Gustav Jung was a brilliant psychiatrist who
                          created and established the longstanding foundation
                          for human typology and psychological types with
                          Extraverted/Introverted, Intuition/Sensation, and
                          Feeling/Thinking that work alongside and coexist with
                          the Court Cards of the Tarot. The typology coexist
                          with the Court Cards because the versions of the Cards
                          most prominently discussed by Aleister Crowley match
                          up with the types that Jung presents; for example,{" "}
                          <i>“Wands”</i> matches up with the <i>“INtuition”</i>{" "}
                          or intuitive function that Jung described,{" "}
                          <i>“Cups”</i> coexist and work alongside{" "}
                          <i>“Feelings”</i>, <i>“Swords”</i> with{" "}
                          <i>“Thinking”</i>, and <i>“Pentacles”</i> with{" "}
                          <i>“Sensation”</i>. While Tarot Cards have existed for
                          hundreds of years, their interpretations have varied
                          but Aleister Crowley’s interpretation has been the
                          most accurate in terms of their relation to Jungian
                          typology and how people interpret themselves and
                          others.
                        </p>

                        <p>
                          When it comes to the Tarot Cards and being able to
                          correctly and effectively read the cards, it can be
                          difficult as human psychology shifts from childhood to
                          adolescence to adulthood to old age which alters the
                          meaning and understanding of the Cards. What is meant
                          by this is that a person could be a <i>“Princess”</i>{" "}
                          when they are younger because oftentimes this card
                          represents young energetic people who are in the
                          process of developing a sense of self, but as they
                          grow older they may shift to being a more practical,
                          sturdy, and extraverted individual progressing into
                          adulthood like a <i>“Knight”</i>.
                        </p>

                        <p>
                          Aside from consulting the zodiac, there is the newer
                          method of assigning Tarot Court Cards from the
                          principles of modern psychology, the method is the
                          MBTI (Myer-Brigg Type Indicator). This method is a
                          behavioral test that an individual takes which
                          accurately describes in detail their personality along
                          with their strengths and weaknesses, romantic
                          relationships, careers, and an in-depth introduction
                          to their personality type. Oftentimes this test is
                          used by employers to gauge how compatible an
                          individual is with the company and other people in the
                          officeor organization. MBTI’s foundation is based on
                          the work by C.G. Jung about how human psychology in
                          general is based on the four cognitive functions:
                          feeling, sensation, intuition, and thinking. These
                          four cognitive functions are then taken in two
                          directions, being either introverted or extraverted;
                          combined with the four cognitive functions and the two
                          directions, it creates, in total, 8 major
                          functions.Isabel Myers and Katherine Briggs then added
                          an additional set of secondary personality types:
                          evaluation and reception that also show extroverted
                          and introverted nature. Thus now creating 16
                          personality types, each corresponding with the 16
                          Court Cards of the Tarot.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block2_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block2_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block2_img.webp"
                                            /> */}
                      <img
                        className={styles.block2_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block2_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>
                        <p>
                          If one stops to think about what they have learned in
                          regard to <i>“personality types”</i> of the Tarot
                          Cards they are based on level, suit, and astrology. As
                          mentioned briefly above, the Court Cards of the Tarot
                          correspond with the personality types in MBTI. For
                          example, Queens and Princesses are people who are more
                          concerned with internal matters, one can consider them
                          introverted and then with Knights and Princes they are
                          concerned with external matters in the kingdom and
                          protecting their people they can be considered
                          extraverted. Then together Knights and Queens are
                          generally portrayed as old and experienced and who are
                          dominated by judgments while Princes and Princesses
                          tend to be aware.
                        </p>

                        <p>
                          Based on what was discussed in the paragraph above, an
                          example would be the Princess of Pentacles, which is
                          dominated by the Earthy part of Earth, who is ISFP:
                          Introvert (I), Sensation (S), Feeling (F), and
                          Prospecting (P). Between Jungian typology, MBTI, and
                          the Court Cards of the Tarot it can be seen that at
                          some point they all interact and connect with one
                          another, they all intertwine with one another because
                          they all have the same objective in mind: helping
                          others understand themselves better as well as
                          everyone they surround themselves with.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.block3_full_width} ${styles.block3_full_width_blue_sec}`}
                >
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={styles.block3_blue_box_full_width}>
                      <div className={styles.yellow_heading}>
                        <h1>Tarot Cards version of MBTI</h1>
                      </div>
                      <div className={styles.block3_blue_box_sub_cont_part}>
                        <div className={styles.blue_box_sub_cont_part1}>
                          <h5>Wands Tarot cards</h5>
                          <p>Intuition</p>
                        </div>

                        <div
                          className={`${styles.blue_box_sub_cont_part1} ${styles.sub_cont_part2}`}
                        >
                          <h5>Cups Tarot cards</h5>
                          <p>Feelings</p>
                        </div>

                        <div
                          className={`${styles.blue_box_sub_cont_part1} ${styles.sub_cont_part3}`}
                        >
                          <h5>Swords Tarot cards</h5>
                          <p>Thinking</p>
                        </div>

                        <div
                          className={`${styles.blue_box_sub_cont_part1} ${styles.sub_cont_part4}`}
                        >
                          <h5>Pentacles Tarot cards</h5>
                          <p>Sensing</p>
                        </div>
                      </div>
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.tarot_typology_text_box_bfr}>
                        <div className={styles.border_box}></div>
                        <p>
                          Furthermore, 16 MBTI personality types are identified
                          by the Myers-Briggs method corresponding to 16 Tarot
                          Court cards. If we stop to think about what we have
                          learned about the <i>“personality types”</i> of cards
                          based on level, suit, and astrology, we can understand
                          which card corresponds to which personality type in
                          MBTI. For example, Kings and Knights, conquerors and
                          rulers in nature, canbe considered <i>“extrovert”</i>{" "}
                          ; Queens and Pages, more interested in internal
                          matters, can be considered <i>“introverted”</i>. Kings
                          and Queens, old and experienced, are often dominated
                          by <i>“judgments,”</i> while Knights and Pages tend to{" "}
                          <i>“be aware”</i>.
                        </p>

                        <p>
                          <b>
                            Thus, based on each pair above, we may have noticed
                            the Knight of Wands, dominated by Air-Fire, is an
                            Extrovert (E), iNtuition (N), Thinking (T) and
                            Judgment (J). Therefore, <i>“ENTJ”</i> is the type
                            of personality of the King of Wands.
                          </b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block4_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block4_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block4_img.webp"
                                            /> */}
                      <img
                        className={styles.block4_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block4_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Knight of Wands (ENTJ-Commander)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, N=INtuition, T=Thinking, J=Judging
                        </h5>

                        <p>
                          Fiery part of Fire. This type are natural-born
                          leaders, they are people who are determined and enjoy
                          achievement. This is the Fire element which is
                          accompanied with a strong, dominant personality that
                          feeds into their leadership style. People with this
                          personality type embody the gifts of charisma and
                          confidence, and project authority in a way that draws
                          crowds together behind a common goal. These people
                          seek out challenges whether they are large or small,
                          they have an internal drive that pushes them to
                          achieve their goals no matter what it takes and they
                          personally believe they can accomplish anything they
                          set their minds to. This personality is relentless and
                          unforgiving, they push towards their goals with sheer
                          willpower. Their confidence can oftentimes lead to
                          pride in themselves and their abilities. With their
                          fierce determination, this personality type oftentimes
                          pushes people along when them, achieving spectacular
                          results in the process. ENTJs are natural
                          team-builders, they have a talent for seeing potential
                          in individuals. A flaw that this type has, however, is
                          they call out the failures of others with cold
                          insensitivity which therefore creates an aura of a{" "}
                          <i>“larger than life”</i> persona. They see displaying
                          emotions as a sign of weakness. They are true
                          powerhouses, but they need a team to work with and
                          share their successes with, they are incredibly
                          powerful but need to also recognize their support
                          system. This personality type can seem or even become
                          arrogant and condescending towards others.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block5_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block5_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block5_img.webp"
                                            /> */}
                      <img
                        className={styles.block5_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block5_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Knight of Cups (ENFJ- Protagonist)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, N=INtuition, F=Feeling, J=Judging{" "}
                        </h5>

                        <p>
                          Fiery part of Water. The ENFJ personality type are the
                          warm, welcoming, amiable, and sincere individuals who
                          find joy and passion in helping others. This type of
                          person has strong values, ethics, and ideas that are
                          contagious to those around them; they are natural
                          leaders who have a knack for creating an environment
                          where they teach because they rarely shy away from
                          doing what is morally correct.{" "}
                          <span>
                            These people find great joy in helping to guide
                            their loved ones and people they hold dear to their
                            heart to grow and change into being their best and
                            most genuine selves.
                          </span>{" "}
                          This type does not feel the need to be the center of
                          attention, they like to play their roles in the
                          background, they do not require praise for their
                          actions. ENFJ has a way with words where people listen
                          to what they have to say, they have a certain
                          sensitivity with their vocality which resonates with
                          others in a way that they remember. The ENFJ are
                          authentic and altruistic people who genuinely care for
                          others, they make it a goal and priority in their life
                          to give aid to anyone and everyone. They are pure
                          individuals, and they have pure intent behind their
                          actions and their words, they have the desire and
                          motivation to help others and have no ulterior motives
                          behind their actions. However, if this personality
                          pushes too hard on certain matters, those around them
                          often feel poorly and unfairly judged; some people
                          also feel like this personality type can be preachy
                          and domineering. But this personality type is
                          passionate about what they believe in and what they
                          believed to be right, and they will fight for what
                          they know to be true.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block6_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block6_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block6_img.webp"
                                            /> */}
                      <img
                        className={styles.block6_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block6_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Knight of Swords (ESTJ- Executive)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, S=Sensation, T=Thinking, J=Judging{" "}
                        </h5>

                        <p>
                          Fiery part of Air. This type has a practical and
                          pragmatic personality, they follow their own sense of
                          judgment. They are a supporter and upholder of
                          tradition and order, they are the embodiment of
                          honesty, dedication, and dignity, and they speak with
                          clear advice and guidance. They have a strong
                          leadership role, they lead by example where they
                          demonstrate dedication and loyalty. Other people tend
                          to rely on this personality type to guide and direct
                          them through adverse times, people trust in this type
                          to make the best decisions. They make order out of
                          chaos. The ESTJ are very knowledgeable and live in a
                          world of clear facts, they stick to what they
                          genuinely believe in because even in resistance they
                          have facts and knowledge to counter it. However, they
                          do not tolerate laziness especially in the workplace.
                          They also expect their dedication and reliability to
                          be reciprocated, and if it is not this type tends to
                          lash out and gain the reputation of being inflexible
                          and cruel in the sense of how heshe communicates with
                          others.
                          <span>
                            {" "}
                            This type are strong believers in the rule of law
                            and authority which is to be earned.
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block7_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block7_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block7_img.webp"
                                            /> */}
                      <img
                        className={styles.block7_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block7_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Knight of Pentacles (ESFJ- Consul) </h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, S=Sensation, F=Feeling, J=Judging
                        </h5>

                        <p>
                          Fiery part of Earth. This type is a very sociable
                          person who deeply cares about other people, and wants
                          to help and serve them in any way that he/she can. An
                          ESFJ is very generous with their time and abilities
                          especially when it comes to helping others. However,
                          if their abilities and generosity are forgotten or go
                          unnoticed they take it personally and it tends to
                          damage their self-esteem as well as they lash out
                          aggressively because of it. This type is loyal to
                          their core and will do anything for their loved ones
                          and friends. This type is really good at giving advice
                          to others because they feel that it is their duty and
                          they are the type of people who genuinely wants to
                          help. They are selfless and opinionated, but if one
                          disagrees with them, they struggle to accept that they
                          may be wrong. They also might come off as
                          self-righteous because they have a tendency to judge
                          others and the path that they’re on as they are
                          ‘misguided’. An ESFJ has a profound respect for
                          tradition and doing things the conventional way. They
                          have a high tendency to build long-lasting and loving
                          relationships with others and they stay loyal to those
                          people forever, even when they are no longer needed or
                          available. They find peace and happiness when they
                          focus on what they love to do, which is setting an
                          example of love and care, being considerate, and being
                          responsible.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block8_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block8_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block8_img.webp"
                                            /> */}
                      <img
                        className={styles.block8_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block8_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Queen of Wands (INTJ- Architect)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, N=INtuition, T=Thinking, J=Judging
                        </h5>

                        <p>
                          Watery part of Fire. This type of person is a
                          tactician through and through, they apply creativity
                          and rationality to every aspect of their life. While
                          their personal lives may be private and complex, but
                          in public settings their confidence, quick wits, and
                          rationality draws others to them. This type is
                          adaptable, has persistent energy, and has calm
                          authority. This personality type draws their
                          self-esteem and self-confidence from their vast
                          knowledge and intelligence, they can ruin themselves
                          if they cannot meet their own expectations for
                          themselves. The INTJ acts and does everything
                          independently, relying only on their own intellect,
                          and they may come across as rude or offensive when
                          they are only trying to be honest, they sometimes come
                          off as snobbish. They can also be seen as
                          perfectionists, needing to do most things by
                          themselves. INTJ are tactical in the way that they
                          make decisions because they contemplate the pros and
                          cons in every situation before they make their move.{" "}
                          <span>
                            They have a drive to be successful as well as
                            inventive, they have a single-minded drive in all
                            that they do.
                          </span>{" "}
                          This type is kind yet is impatient when it comes to
                          being opposed by others. They have a vast capacity for
                          friendship and love, but they have to be the ones to
                          initiate it all.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block9_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block9_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block9_img.webp"
                                            /> */}
                      <img
                        className={styles.block9_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block9_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Queen of Cups (INFJ- Advocate)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, N=INtuition, F=Feeling, J=Judging
                        </h5>

                        <p>
                          Watery part of Water. This is a rare type, they tend
                          to have a deep thoughtfulness and imagination
                          concerning their approach to life. They have deep
                          inner values and visions as well as humanism that
                          guides and directs them in all that they do. This type
                          wants to make a real difference in the world, they
                          don’t sit and watch as their life goes by. They are
                          creative, have great imaginations, and are very
                          sensitive. They are also very patient.{" "}
                          <span>
                            They have a passion for helping others and being a
                            good force in the lives of others.
                          </span>{" "}
                          The INFJ have a clear sense of purpose and stick to
                          their values, that’s what leads them through life.
                          Since this is an Introverted type, they need time to
                          themselves to reflect on their life and their role in
                          the world. While the majority of the time they are
                          focused on others, they need to remember to find time
                          to take care of themselves. They may focus so intently
                          on their ideals that they don’t take adequate care of
                          themselves – a pattern that can lead to stress and
                          burnout. This type balances logic and their emotions,
                          the head and the heart, and they try to correct the
                          fallacies in the world paying no attention to how
                          large or small the issue is. They find joy in
                          uplifting others and spreading compassion; this type
                          enjoys meaningful conversations and they tend to
                          communicate in a way that is warm and sensitive which
                          therefore resonates with the people they connect with.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block10_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block10_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_bloc10_img.webp"
                                            /> */}
                      <img
                        className={styles.block10_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_bloc10_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Queen of Swords (ISTJ: Logistician)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, S=Sensation, T=Thinking, J=Judging
                        </h5>

                        <p>
                          Watery part of Air. This type is reserved, methodical,
                          and has a rational outlook on life. The ISTJ are
                          logical and believe that there is a correct way to go
                          about things in any and every situation. They stay
                          grounded in every situation and use their practical
                          skills to work through problems which earns respect
                          from those around them.{" "}
                          <span>
                            These individuals find comfort in structure and
                            traditions. These are highly dependable people who
                            stay loyal to their friends and family, they often
                            offer clarity in murky situations
                          </span>
                          . An ISTJ, however, has a tendency to misjudge people
                          who cannot mirror their self-control; if they suspect
                          that someone is lazy or dishonest (ISTJ strongly
                          believe in honesty and integrity) when the ISTJ does
                          not know their situation, they don’t vocalize their
                          disdain but one can catch onto their feelings which
                          gives them a reputation of being strict and
                          unempathetic. An ISTJ has a very strong work ethic and
                          sense of duty that some people take advantage of, an
                          ISTJ sometimes shoulders a lot of other people’s
                          responsibilities. This type has a pragmatist
                          personality which gives them a great sense of
                          organization, they find great passion in creating
                          order and harmony in situations that are chaotic.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block11_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block11_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block11_img.webp"
                                            /> */}
                      <img
                        className={styles.block11_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block11_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Queen of Pentacles (ISFJ: Defender)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>I=Introvert, S=Sensation, F=Feeling, J=Judging</h5>

                        <p>
                          Watery part of Earth. This type are efficient and
                          responsible, they are warm and humble in their own
                          way. They are very hardworking and devoted to people,
                          especially their close friends and family, they feel a
                          special sense of duty to those they surround
                          themselves with. An ISFJ tends to help those around
                          them reach their full potential, they serve everyone
                          and do not seek or need recognition for their help.{" "}
                          <span>
                            This personality type is fiercely loyal, they drop
                            whatever they are doing to give a hand to their
                            friends or family
                          </span>
                          . They take their responsibilities very seriously,
                          they are devoted to every task they are given. They
                          have obtained and honed developed people skills as
                          well as social relationships. They are sensitive and
                          caring people who have a special ability to make those
                          around them feel cherished and valued. On the other
                          hand, sometimes they bite off more than they can chew
                          and can feel guilty, stressed, and burnt out. They can
                          be seen as perfectionists because they have a tendency
                          to be meticulous with the details of things. They are
                          also slow to adapt to changes, which can bring immense
                          stress into their lives.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block12_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block12_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_bloc12_img.webp"
                                            /> */}
                      <img
                        className={styles.block12_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_bloc12_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Prince of Wands (ENTP: Debater)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, N=INtuition, T=Thinking, P=Prospecting
                        </h5>

                        <p>
                          Airy part of Fire. This personality type is very
                          strategic, deconstructing and rebuilding ideas with
                          great mental agility. They tend to be creative and
                          bold with a great, playful sense of humor and are
                          highly entertaining. Their idea of fun generally has
                          to do with a spirited debate of sorts. This type has a
                          sincere heart seeking to benefit everyone. While they
                          quarrel and debate most everyone, people can only have
                          their ideas challenged for so long, so oftentimes an
                          ENTP can burn bridges easily.{" "}
                          <span>
                            They are quick-witted and fearless, they are not
                            afraid to push back against societal norms
                          </span>
                          . An ENTP does not have boundaries, they often seek
                          out challenges and seek to challenge everything, this
                          goes with their rebelliousness. People with this
                          personality are very knowledgeable and eager to learn
                          new things. These individuals are confident,
                          intelligent, and have a keen sense of humor, but
                          unless they cultivate a bit of sensitivity, they may
                          struggle to maintain deeper relationships to achieve
                          their goals. This type does not conform to society or
                          the norms they set for people. The ENTP feels that
                          people too often succumb to pressures and standards of
                          society, they want to be the people that stand out
                          against the crowd and do their own thing. They explore
                          new perspectives, they recognize the value of
                          consideration and compromise alongside logica and
                          progress. However, this personality may seem
                          controversial, self-righteous, and unrealistic.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block13_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block13_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block13_img.webp"
                                            /> */}
                      <img
                        className={styles.block13_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block13_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Prince of Cups (ENFP: Campaigner)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, N=INtuition, F=Feeling, P=Prospecting
                        </h5>

                        <p>
                          Airy part of Water. This individual has and embraces
                          ideas bigger than this world which reflects their
                          sense of hope and compassion towards others. These
                          types of people are the true free spirits who are
                          unreserved, accepting, and kind. An ENFP longs for a
                          deep, meaningful connection and relationship with
                          people, they are friendly and they want to enrich the
                          lives of the people they surround themselves with.{" "}
                          <span>
                            They are both vibrant on the exterior as well as the
                            interior, their hearts are pure and believe that
                            everything is connected.
                          </span>{" "}
                          They have an inspiring personality that attracts
                          others to them, they inspire others to open their
                          hearts and minds to new possibilities and they try to
                          help bear the burdens and problems of others. However,
                          this type tends to struggle with self-discipline and
                          consistency, they also read too much into other
                          people’s actions. They have a habit of overthinking a
                          situation and try too hard to please those around
                          them, they become unfocused and disorganized. But they
                          enjoy exploring new and different kinds of
                          relationships and ideas, they genuinely believe that
                          everyone deserves to express their feelings and
                          desires.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block14_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block14_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_bloc14_img.webp"
                                            /> */}
                      <img
                        className={styles.block14_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_bloc14_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Prince of Swords (ESTP: Entrepreneur)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, S=Sensation, T=Thinking, P=Prospecting
                        </h5>

                        <p>
                          Airy part of Air. This type are the energetic,
                          confident, and action-oriented people who navigate any
                          problem they are faced with. This is the type who
                          loves to be the center of attention, has an odd sense
                          of humor, and is a person people admire. An ESTP acts
                          before thinking, they try to fix their mistakes as
                          they go along, they make their lives based around
                          risky behavior. They are impulsive, and even though
                          they have good intentions, it can lead to a
                          thoughtless decision. They have their own internal,
                          moral compass that guides and directs them through
                          life. This type enjoys drama and passion which are
                          appealing to their logical minds. An ESTP is very
                          perspective and often notices small details and
                          changes in a person, they are very observant. This
                          type calls out the changes they see without thinking
                          about the consequences, giving others the impression
                          that this type is insensitive.{" "}
                          <span>
                            This type often gets stuck in the moment and forgets
                            to take care of their own health and safety
                          </span>
                          . An ESTP is inspiring which makes them a natural
                          leader pulling everyone along the less traveled path.
                          They tend to bring excitement and life everywhere they
                          go.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block15_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block15_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block15_img.webp"
                                            /> */}
                      <img
                        className={styles.block15_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block15_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Prince of Pentacles (ESFP: Entertainer)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          E=Extraverted, S=Sensation, F=Feeling, P=Prospecting
                        </h5>

                        <p>
                          Airy part of Earth. This type is the energetic and
                          vibrant person who takes pleasure in discovering new
                          and unknown things. They are very social and make
                          friends easily, they push people to open up and have
                          fun. An ESFP is very talkative and has a great sense
                          of humor, they love to laugh and be the center of
                          attention.{" "}
                          <span>
                            They find their greatest joy is when they are having
                            fun with their friends and family
                          </span>
                          . They also have a keen eye for fashion and details, a
                          person can see it in all parts of an ESFP’s life. They
                          love the beautiful and simple things in life. This
                          type is very observant and sensitive to other people’s
                          emotions, they want to help them feel wanted and
                          included in any setting. They love bringing other
                          people joy, they love to bring others on their
                          adventures and make memories with them. This type
                          recognizes value and quality, which is a fine trait.
                          However, this type does not do well with
                          confrontation, they are conflict-averse where they
                          ignore conflict altogether.{" "}
                          <span>
                            They also do not do well with long-term planning,
                            for example long-term financial planning is a
                            struggle for them, this also makes them unfocused
                          </span>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block16_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block16_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block16_img.webp"
                                            /> */}
                      <img
                        className={styles.block16_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block16_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Princess of Wands (INTP: Logician)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, N=INtuition, T=Thinking, P=Prospecting
                        </h5>

                        <p>
                          Earthy part of Fire. This type of person is shy but a
                          flexible thinker, they seek out the path less traveled
                          and enjoy experimenting with personal creativity. They
                          are extremely individual and brilliant. They are
                          reserved and become drained from socializing, but when
                          they find someone who connects with them on an
                          intellectual level and matches their mental energy
                          they bloom and light up to the point where they
                          confide in that person for everything. This type has a
                          reputation for being pensive, detached, and
                          unapproachable.{" "}
                          <span>
                            An INTP thoroughly enjoys swapping ideas and having
                            deep conversations with others that match their
                            energy, they have a curious and inquiring soul that
                            allows them to think deeply
                          </span>
                          . This personality type is completely mystified by
                          human nature and the idea that humans make decisions
                          and act upon emotions and feelings. They are ambitious
                          and full of enthusiasm. They feel most comfortable in
                          the space of rationality and reason. These individuals
                          are not necessarily unfeeling, but they do not know
                          how to express their feelings to their friends and
                          loved ones. An INTP struggles with overthinking a lot
                          of things because oftentimes they are stuck in their
                          own minds as they are thinking all of the time. But if
                          they do find themselves stuck, they have everything
                          they need in order to pull themselves out of the
                          situation.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block17_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block17_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block17_img.webp"
                                            /> */}
                      <img
                        className={styles.block17_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block17_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Princess of Cups (INFP: Mediator)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, N=INtuition, F=Feeling, P=Prospecting
                        </h5>

                        <p>
                          Earthy part of Water. This is a rare personality type,
                          the people are quiet, open-minded, and creative. They
                          are kind and caring, and put a touch of happiness and
                          creativity into everything they do. An INFP is often
                          lost in daydreams and their imagination, inventing a
                          wide array of stories and images in their minds. This
                          type is known for their sensitivity and emotional
                          response to arts like music, nature, and art.{" "}
                          <span>
                            These people yearn to understand the people around
                            them, while they are also very introspective and
                            highly attuned to their own thoughts and feelings
                          </span>
                          . They long for deep, soulful relationships, and they
                          feel called to help others. This type are
                          compassionate and nonjudgmental, they listen and are
                          attentive to other people’s stories. They can’t help
                          but muse about the meaning and purpose of life,
                          dreaming up all sorts of stories, ideas, and
                          possibilities along the way. They do have to reel
                          themselves in before they become frustrated, they have
                          to make their dreams into reality or else they become
                          frustrated and feel that they are incapable of
                          accomplishing their dreams. Empathy is one of the
                          greatest gifts an INFP possesses, but at times it can
                          be a liability because they feel there are too many
                          things to be set right. This quiet belief in doing the
                          right thing may explain why these personalities so
                          often inspire compassion, kindness, and beauty
                          wherever they go. They tend to be unrealistic and
                          self-isolating as well as self-critical.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block18_full_width}>
                  <div className={styles.tarot_typology_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                                                className={styles.block18_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block18_img.webp"
                                            /> */}
                      <img
                        className={styles.block18_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block18_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Princess of Swords (ISTP: Virtuoso)</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, S=Sensation, T=Thinking, P=Prospecting
                        </h5>

                        <p>
                          Earthy part of Air. This type has an individualistic
                          mindset who loves to explore everything, they do not
                          need much of a connection with an external source they
                          love to pursue goals and things alone. They love
                          observing and exploring the world around them and how
                          it all works, they view it all rationally and with
                          curiosity. They love to do things with their hands,
                          they enjoy creating and going through the trial and
                          error phase, trying things first-hand and experiencing
                          it all for themselves. This type is quite friendly but
                          they enjoy having their own private life, they are
                          spontaneous yet calm. An ISTP has a habit of acting
                          before thinking about it, they act too soon which
                          leads to problems when they expect those around them
                          to do the same thing. Their decisions come from a
                          sense of practical realism, they have the idea of
                          direct fairness at their heart. They pursue and
                          explore relationships through their actions rather
                          than empathy which leads to numerous problems because
                          they do not know how to set boundaries, they just go
                          with the flow.{" "}
                          <span>
                            They tend to have risky behavior, they enjoy taking
                            risks
                          </span>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block19_full_width}>
                  <div className={styles.tarot_typology_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                                                className={styles.block19_part1_img}
                                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block19_img.webp"
                                            /> */}
                      <img
                        className={styles.block19_part1_img}
                        src={`${process.env.cloud_url2}transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block19_img.webp`}
                      />
                    </div>
                    <div className={styles.tarot_typology_text_box}>
                      <div className={styles.border_box}></div>

                      <div className={styles.yellow_heading}>
                        <h1>Princess of Pentacles (ISFP: Adventurer):</h1>
                      </div>

                      <div className={styles.tarot_typology_text_box_bfr}>
                        <h5>
                          I=Introverted, S=Sensation, F=Feeling, P=Prospecting
                        </h5>

                        <p>
                          Earthy part of Earth. This type tends to have an open
                          mind and they approach life and new experiences with
                          warmth, they love to stay and live in the moment. This
                          is a deeply emotional type and they treasure beauty,
                          life is a canvas of self-expression where they can
                          paint whatever they want and be whoever they want
                          without worrying about what others think. This is a
                          purely unique personality type. They enjoy art, music,
                          and poetry, they think deeply about life and tend to
                          find the best things every day. Being deeply
                          emotional, this type is also very much introverted
                          meaning they have to recharge after a social
                          gathering, they need time to themselves.{" "}
                          <span>
                            An ISFP is driven by curiosity and has an
                            exploratory spirit
                          </span>
                          . They love to try new things and explore an array of
                          passions and interests, they have a flexible and
                          adaptable approach to life and they make sure to leave
                          room in their life for the unexpected. With their
                          specific approach to the way they live their lives,
                          some of their favorite moments and memories are from
                          spontaneous adventures they go on with their friends
                          and family. Their mindset helps them have an open-mind
                          and are tolerant to a majority of the things life
                          throws at them.{" "}
                          <span>
                            This personality type loves diversity and living in
                            a world where there are all sorts of people, it
                            keeps things interesting for them
                          </span>
                          . An ISFP is very perceptive and is able to pick up on
                          and identify people’s unspoken emotions, it can make
                          this type upset if they feel that they are not liked
                          or approved of; they also do not do well with
                          criticism and they often lose their temper when they
                          are being unfairly criticized. This type also
                          struggles with long-term plans of any sort, with that
                          being said they also do not stick to their plans. They
                          have an air and spirit of freedom that surrounds them,
                          they love to be flexible and enjoy having their minds
                          changed. An ISFP tends to have a cloudy view of their
                          uniqueness and ability to achieve their goals and
                          worry about letting others down.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* -----------------------------------Tarot-Typology-Part2-END--------------------------------------- */}

      {/* <div className={styles.part2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/tarot_typology/tarot_typology_part2_block15_to_19_img.webp'></img>
            </div> */}

      {/* ////////////////////////////////////BISWARUP////////////////////////////////// */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={styles.banner_modal_main}
      >
        <Box className={styles.banner_modal_box}>
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className={styles.modal_banner}
          >
            <div className={styles.sub_modal_banner}>
              <span className={styles.close_btn} onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
